<div class="container pl-md-0">
  <div class="d-flex justify-content-between align-items-center">
    <app-account-header i18n-title title="My Orders"></app-account-header>
  </div>

  <app-order-history></app-order-history>

  <app-cc-order-history></app-cc-order-history>
</div>
